module.exports = __webpack_public_path__ + "img/CastleofBlaine.fb4c8238.png";